import { render, staticRenderFns } from "./PinnedItemsBar.vue?vue&type=template&id=24c0026f"
import script from "./PinnedItemsBar.vue?vue&type=script&lang=js"
export * from "./PinnedItemsBar.vue?vue&type=script&lang=js"
import style0 from "./PinnedItemsBar.vue?vue&type=style&index=0&id=24c0026f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports